import React from 'react';

import { translationKey } from '@change-corgi/core/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';

import { SapCtaBanner } from '#src/app/shared/components/SapCtaBanner';

export const CTASection: React.FC = () => {
	const track = useTracking();

	return (
		<SapCtaBanner
			headingKey={translationKey('corgi.topic_page.cta.alt_section_text')}
			buttonKey={translationKey('corgi.topic_page.steps.button')}
			sourceLocation="topics_cta"
			className="flex flex-col items-start justify-between gap-6 px-6 py-6 max-sm:items-stretch md:flex-row md:items-center md:px-10"
			buttonClassName="max-md:w-full"
			buttonQa="footer-sap-button"
			onButtonClick={() => {
				void track('topic_sap_click_bottom');
			}}
		/>
	);
};
